import { Checkbox } from '@apollo/orbit';
import classnames from 'classnames';
import React, { useCallback } from 'react';

interface ClientFilterVersionItemProps {
  name: string;
  onClientSelected: (params: {
    checked: boolean;
    clientName: string;
    version: string;
  }) => void;
  selected: boolean;
  version: string;
}

export const ClientFilterVersionItem = ({
  name,
  onClientSelected,
  selected,
  version,
}: ClientFilterVersionItemProps) => {
  const handleCheckboxClick = useCallback(
    (activated: boolean) => {
      onClientSelected({ clientName: name, version, checked: activated });
    },
    [name, onClientSelected, version],
  );
  const isAllVersionsItem = version === '*';
  const isNoVersionSpecifiedItem = version === '';

  return (
    <Checkbox
      isChecked={selected}
      className={classnames('flex items-center py-[6px]', {
        italic: isAllVersionsItem || isNoVersionSpecifiedItem,
      })}
      data-testid={`${name}.${version}`}
      onChange={(e) => handleCheckboxClick(e.target.checked)}
    >
      {isAllVersionsItem
        ? 'Any version (includes future versions and any others not listed)'
        : isNoVersionSpecifiedItem
          ? 'Without a version'
          : version}
    </Checkbox>
  );
};
